import { Action, Dispatch } from 'redux';
import initialState from '../initialState';
import { getApi } from '../api/ApiProvider';
import { default as StoreModel, LoadedResource } from './StoreModel';

export enum OrderActionTypes {
    FETCH_REQUEST = '[ORDER][LIST] Request',
    FETCH_RESPONSE = '[ORDER][LIST] Response',
    FETCH_ERROR = '[ORDER][ERROR] error',
    ADD_USER_REQUEST = '[ORDER][ADD] Request',
    ADD_USER_RESPONSE = '[ORDER][ADD] Response',
    ADD_USER_ERROR = '[ORDER][ADD] Error',
}

export interface OrderState {
    data: LoadedResource<any>,
}

export default (
    state: OrderState = initialState.order,
    action?: Action<OrderActionTypes> & { payload: any }): OrderState => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case OrderActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: StoreModel.fetching()
            };

        case OrderActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: StoreModel.result(action.payload)
            };

        case OrderActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: StoreModel.error(action.payload)
            };

        default:
            return state;
    }
};

export class OrderActions {

    fetchByRace(raceId: string) {
        return (dispatch: Dispatch) => {
            dispatch({ type: OrderActionTypes.FETCH_REQUEST });
            getApi().order().byRaceId(raceId).then(data => {
                dispatch({ type: OrderActionTypes.FETCH_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: OrderActionTypes.FETCH_ERROR, payload: err });
            })

        }
    }

}



// WEBPACK FOOTER //
// ./src/store/order.ts